import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../utils/axiosAuth";

// Async thunk لجلب بيانات أوردرات نقاط البيع بالساعة
export const fetchOrdersPerHour = createAsyncThunk(
  "ordersSource/fetchOrdersPerHour",
  async (requestData, { rejectWithValue }) => {
    try {
      const response = await api.post("/api/orders-per-hour", requestData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.error || "حدث خطأ أثناء جلب البيانات"
      );
    }
  }
);

const ordersSourceSlice = createSlice({
  name: "ordersSource",
  initialState: {
    data: [],
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
    date: null,
    from_hour: null,
    to_hour: null,
    tabletBranchCount: null,
    allTabOrders: null,
    allAvgTabPercentage: null,
  },
  reducers: {
    clearSourceData: (state) => {
      state.data = [];
      state.status = "idle";
      state.error = null;
      state.date = null;
      state.from_hour = null;
      state.to_hour = null;
      state.tabletBranchCount = null;
      state.allTabOrders = null;
      state.allAvgTabPercentage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrdersPerHour.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchOrdersPerHour.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.hourly_data || [];
        state.date = action.payload.date;
        state.from_hour = action.payload.from_hour;
        state.to_hour = action.payload.to_hour;
        state.tabletBranchCount = action.payload.tablet_branch_count ?? null;
        state.allTabOrders = action.payload.all_tab_orders ?? null;
        state.allAvgTabPercentage = action.payload.all_avg_tab_percentage ?? null;
        state.error = null;
      })
      .addCase(fetchOrdersPerHour.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        state.data = [];
        state.date = null;
        state.from_hour = null;
        state.to_hour = null;
        state.tabletBranchCount = null;
        state.allTabOrders = null;
        state.allAvgTabPercentage = null;
      });
  },
});

export const { clearSourceData } = ordersSourceSlice.actions;
export default ordersSourceSlice.reducer;
